



















import { Component } from 'vue-property-decorator';
import DescriptionBar from './DescriptionBar.vue';
import ScoreInputBase from './ScoreInputBase';

@Component({ components: { DescriptionBar } })
export default class Stars extends ScoreInputBase {
  public accessibleName(score: number): string {
    const option = this.$t('generic.scoreOption', { score }) as string;
    return this.accessibleLabel ? `${this.accessibleLabel}: ${option}` : option;
  }
}
